import { gql } from '@apollo/client';

const checkpointReappraisalRationaleReviewFragment = gql`
  fragment CheckpointReappraisalRationaleReviewFields on CheckpointReappraisalRationaleReview {
    Id
    Status
    Comment
    ReviewerName
    AppraisalProgramYear
    CheckPointDocumentFileUrl
    MddapOrgUnit {
      Name
      MddapOrganization {
        Name
      }
    }
  }
`;

export default checkpointReappraisalRationaleReviewFragment;
